import { Redirect } from 'react-router-dom';

export default function BillingAdmin() {
  return (
    <Redirect to="/billing/plan" />
  );
}